// // //08-01-2026

// // import React, { useEffect, useState } from "react";
// // import { Plus } from "lucide-react";
// // import { motion, AnimatePresence } from "framer-motion";
// // import { useNavigate } from "react-router-dom";

// // import PropertyCard from "../components/properties/PropertyCard";
// // import PropertyForm from "../components/properties/PropertyForm";
// // import PropertyFilters from "../components/properties/PropertyFilters";

// // import api from "../api/api";
// // import { useAuth } from "../api/authContext";

// // import "../css/properties/propertypage.css";

// // export default function PropertyPage() {
// //   const navigate = useNavigate();
// //   const { token , isAdmin} = useAuth();

// //   const [properties, setProperties] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [showForm, setShowForm] = useState(false);
// //   const [editingProperty, setEditingProperty] = useState(null);

// //   const [filters, setFilters] = useState({
// //     search: "",
// //     sort: "newest",
// //     category: "all",
// //     status: "all",
// //     listingType: "all",
// //   });

// //   /* ================= AUTH GUARD ================= */
// //   useEffect(() => {
// //     if (!token) {
// //       navigate("/login");
// //       return;
// //     }
// //     fetchProperties();
// //   }, [token]);

// //   /* ================= FETCH ================= */
// //   const fetchProperties = async () => {
// //     try {
// //       setLoading(true);
// //       const res = await api.get("/properties"); // ownership handled in backend
// //       setProperties(res.data || []);
// //     } catch (err) {
// //       console.error("Failed to fetch properties", err);
// //       if (err.response?.status === 401) {
// //         navigate("/login");
// //       }
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   /* ================= CREATE / UPDATE ================= */
// //   const handleSubmit = async (data) => {
// //     try {
// //       const formData = new FormData();

// //       // Append all scalar fields except images
// //       Object.keys(data).forEach((key) => {
// //         if (key !== "images" && data[key] !== undefined && data[key] !== null) {
// //           // Arrays like amenities need special handling
// //           if (Array.isArray(data[key])) {
// //             data[key].forEach((item) => formData.append(`${key}[]`, item));
// //           } else {
// //             formData.append(key, data[key]);
// //           }
// //         }
// //       });

// //       if (data.images?.length) {
// //         data.images.forEach((file) => {
// //           if (file instanceof File) {
// //             // New file upload
// //             formData.append("images", file);
// //           } else if (typeof file === "string") {
// //             // Existing server path — send so backend can merge them
// //             formData.append("images", file);
// //           }
// //         });
// //       }

// //       if (editingProperty) {
// //         await api.put(`/properties/${editingProperty._id}`, formData);
// //       } else {
// //         await api.post("/properties/create", formData);
// //       }

// //       fetchProperties();
// //       setShowForm(false);
// //       setEditingProperty(null);
// //     } catch (err) {
// //       console.error("Save property error:", err);
// //       alert("Error saving property");
// //     }
// //   };

// //   const handleStatusChange = async (propertyId, newStatus) => {
// //   try {
// //     await api.patch(`/properties/${propertyId}`, {
// //       status: newStatus
// //     });

// //     // 🔥 update UI instantly
// //     setProperties(prev =>
// //       prev.map(p =>
// //         p._id === propertyId ? { ...p, status: newStatus } : p
// //       )
// //     );
// //   } catch (err) {
// //     console.error("Failed to update status", err);
// //     alert("Failed to update property status");
// //   }
// // };


// //   /* ================= DELETE ================= */
// //   const handleDelete = async (propertyId) => {
// //     if (!window.confirm("Are you sure you want to delete this property?")) return;

// //     try {
// //       await api.delete(`/properties/${propertyId}`);
// //       setProperties((prev) => prev.filter((p) => p._id !== propertyId));
// //     } catch (err) {
// //       console.error("Delete property error:", err);
// //       alert("Error deleting property");
// //     }
// //   };

// //   /* ================= FILTER + SORT ================= */
// //   const filteredProperties = (() => {
// //     const search = (filters.search || "").toLowerCase();

// //     let list = properties.filter((p) => {
// //       const matchSearch =
// //         !search ||
// //         p.propertyName?.toLowerCase().includes(search) ||
// //         p.location?.toLowerCase().includes(search);

// //       const matchStatus =
// //         filters.status === "all" || p.status === filters.status;

// //       const matchCategory =
// //         filters.category === "all" ||
// //         p.propertyCategory === filters.category;

// //       const matchListingType =
// //         filters.listingType === "all" ||
// //         p.listingType === filters.listingType;

// //       return matchSearch && matchStatus && matchCategory && matchListingType;
// //     });

// //     // Client-side sort
// //     switch (filters.sort) {
// //       case "oldest":
// //         list = [...list].sort(
// //           (a, b) => new Date(a.createdDate) - new Date(b.createdDate)
// //         );
// //         break;
// //       case "az":
// //         list = [...list].sort((a, b) =>
// //           (a.propertyName || "").localeCompare(b.propertyName || "")
// //         );
// //         break;
// //       case "za":
// //         list = [...list].sort((a, b) =>
// //           (b.propertyName || "").localeCompare(a.propertyName || "")
// //         );
// //         break;
// //       case "price_asc":
// //         list = [...list].sort((a, b) => (a.price || 0) - (b.price || 0));
// //         break;
// //       case "price_desc":
// //         list = [...list].sort((a, b) => (b.price || 0) - (a.price || 0));
// //         break;
// //       case "newest":
// //       default:
// //         list = [...list].sort(
// //           (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
// //         );
// //         break;
// //     }

// //     return list;
// //   })();

// //   /* ================= UI ================= */
// //   return (
// //     <div className="properties-page">
// //       <div className="properties-header">
// //         <div>
// //           <h1>Property Listings</h1>
// //           <p>Manage your real estate inventory</p>
// //         </div>

// //         <button
// //           className="add-btn"
// //           onClick={() => {
// //             setEditingProperty(null);
// //             setShowForm(true);
// //           }}
// //         >
// //           <Plus size={16} /> Add New Property
// //         </button>
// //       </div>

// //       {/* FILTERS */}
// //       <div className="properties-toolbar">
// //         <PropertyFilters filters={filters} setFilters={setFilters} />
// //       </div>

// //       {/* FORM MODAL */}
// //       <AnimatePresence>
// //         {showForm && (
// //           <motion.div
// //             className="modal-overlay"
// //             initial={{ opacity: 0 }}
// //             animate={{ opacity: 1 }}
// //             exit={{ opacity: 0 }}
// //           >
// //             <motion.div
// //               className="modal-content"
// //               initial={{ scale: 0.9 }}
// //               animate={{ scale: 1 }}
// //               exit={{ scale: 0.9 }}
// //             >
// //               <PropertyForm
// //                 property={editingProperty}
// //                 onSubmit={handleSubmit}
// //                 onCancel={() => {
// //                   setShowForm(false);
// //                   setEditingProperty(null);
// //                 }}
// //               />
// //             </motion.div>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>

// //       {/* GRID */}
// //       <div className="properties-grid">
// //         {loading ? (
// //           <p>Loading properties...</p>
// //         ) : filteredProperties.length === 0 ? (
// //           <p>No properties found</p>
// //         ) : (
// //           filteredProperties.map((property, index) => (
// //             <PropertyCard
// //   key={property._id}
// //   property={property}
// //   index={index}
// //   onEdit={() => {
// //     setEditingProperty(property);
// //     setShowForm(true);
// //   }}
// //   onDelete={() => handleDelete(property._id)}
// //   onStatusChange={handleStatusChange}
// //   isAdmin={isAdmin}
// // />

// //           ))
// //         )}
// //       </div>
// //     </div>
// //   );
// // }

// // Updated: 23-05-2026
// // Changes:
// // - Reads URL query params on mount (status, category, listingType, sort, search)
// //   so Dashboard "Available Properties" link pre-filters to status=available

// import React, { useEffect, useState } from "react";
// import { Plus } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useNavigate, useLocation } from "react-router-dom";

// import PropertyCard    from "../components/properties/PropertyCard";
// import PropertyForm    from "../components/properties/PropertyForm";
// import PropertyFilters from "../components/properties/PropertyFilters";

// import api from "../api/api";
// import { useAuth } from "../api/authContext";

// import "../css/properties/propertypage.css";

// export default function PropertyPage() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { token, isAdmin } = useAuth();

//   const [properties,       setProperties]       = useState([]);
//   const [loading,          setLoading]          = useState(true);
//   const [showForm,         setShowForm]         = useState(false);
//   const [editingProperty,  setEditingProperty]  = useState(null);

//   /* ── Read initial filter values from URL query params ── */
//   const initFilters = () => {
//     const p = new URLSearchParams(location.search);
//     return {
//       search:      p.get("search")      || "",
//       sort:        p.get("sort")        || "newest",
//       category:    p.get("category")   || "all",
//       status:      p.get("status")     || "all",
//       listingType: p.get("listingType") || "all",
//     };
//   };

//   const [filters, setFilters] = useState(initFilters);

//   /* ── Re-apply if URL changes (e.g. dashboard card clicked again) ── */
//   useEffect(() => {
//     setFilters(initFilters());
//   }, [location.search]);

//   /* ================= AUTH GUARD ================= */
//   useEffect(() => {
//     if (!token) {
//       navigate("/login");
//       return;
//     }
//     fetchProperties();
//   }, [token]);

//   /* ================= FETCH ================= */
//   const fetchProperties = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/properties");
//       setProperties(res.data || []);
//     } catch (err) {
//       console.error("Failed to fetch properties", err);
//       if (err.response?.status === 401) navigate("/login");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= CREATE / UPDATE ================= */
//   const handleSubmit = async (data) => {
//     try {
//       const formData = new FormData();

//       Object.keys(data).forEach((key) => {
//         if (key !== "images" && data[key] !== undefined && data[key] !== null) {
//           if (Array.isArray(data[key])) {
//             data[key].forEach((item) => formData.append(`${key}[]`, item));
//           } else {
//             formData.append(key, data[key]);
//           }
//         }
//       });

//       if (data.images?.length) {
//         data.images.forEach((file) => {
//           if (file instanceof File) {
//             formData.append("images", file);
//           } else if (typeof file === "string") {
//             formData.append("images", file);
//           }
//         });
//       }

//       if (editingProperty) {
//         await api.put(`/properties/${editingProperty._id}`, formData);
//       } else {
//         await api.post("/properties/create", formData);
//       }

//       fetchProperties();
//       setShowForm(false);
//       setEditingProperty(null);
//     } catch (err) {
//       console.error("Save property error:", err);
//       alert("Error saving property");
//     }
//   };

//   /* ================= STATUS CHANGE ================= */
//   const handleStatusChange = async (propertyId, newStatus) => {
//     try {
//       await api.patch(`/properties/${propertyId}`, { status: newStatus });
//       setProperties((prev) =>
//         prev.map((p) => p._id === propertyId ? { ...p, status: newStatus } : p)
//       );
//     } catch (err) {
//       console.error("Failed to update status", err);
//       alert("Failed to update property status");
//     }
//   };

//   /* ================= DELETE ================= */
//   const handleDelete = async (propertyId) => {
//     if (!window.confirm("Are you sure you want to delete this property?")) return;
//     try {
//       await api.delete(`/properties/${propertyId}`);
//       setProperties((prev) => prev.filter((p) => p._id !== propertyId));
//     } catch (err) {
//       console.error("Delete property error:", err);
//       alert("Error deleting property");
//     }
//   };

//   /* ================= FILTER + SORT ================= */
//   const filteredProperties = (() => {
//     const search = (filters.search || "").toLowerCase();

//     let list = properties.filter((p) => {
//       const matchSearch =
//         !search ||
//         p.propertyName?.toLowerCase().includes(search) ||
//         p.location?.toLowerCase().includes(search);

//       const matchStatus =
//         filters.status === "all" || p.status === filters.status;

//       const matchCategory =
//         filters.category === "all" || p.propertyCategory === filters.category;

//       const matchListingType =
//         filters.listingType === "all" || p.listingType === filters.listingType;

//       return matchSearch && matchStatus && matchCategory && matchListingType;
//     });

//     switch (filters.sort) {
//       case "oldest":
//         list = [...list].sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
//         break;
//       case "az":
//         list = [...list].sort((a, b) => (a.propertyName || "").localeCompare(b.propertyName || ""));
//         break;
//       case "za":
//         list = [...list].sort((a, b) => (b.propertyName || "").localeCompare(a.propertyName || ""));
//         break;
//       case "price_asc":
//         list = [...list].sort((a, b) => (a.price || 0) - (b.price || 0));
//         break;
//       case "price_desc":
//         list = [...list].sort((a, b) => (b.price || 0) - (a.price || 0));
//         break;
//       case "newest":
//       default:
//         list = [...list].sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
//         break;
//     }

//     return list;
//   })();

//   /* ================= UI ================= */
//   return (
//     <div className="properties-page">
//       <div className="properties-header">
//         <div>
//           <h1>Property Listings</h1>
//           <p>Manage your real estate inventory</p>
//         </div>
//         <button
//           className="add-btn"
//           onClick={() => { setEditingProperty(null); setShowForm(true); }}
//         >
//           <Plus size={16} /> Add New Property
//         </button>
//       </div>

//       {/* FILTERS */}
//       <div className="properties-toolbar">
//         <PropertyFilters filters={filters} setFilters={setFilters} />
//       </div>

//       {/* FORM MODAL */}
//       <AnimatePresence>
//         {showForm && (
//           <motion.div
//             className="modal-overlay"
//             initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
//           >
//             <motion.div
//               className="modal-content"
//               initial={{ scale: 0.9 }} animate={{ scale: 1 }} exit={{ scale: 0.9 }}
//             >
//               <PropertyForm
//                 property={editingProperty}
//                 onSubmit={handleSubmit}
//                 onCancel={() => { setShowForm(false); setEditingProperty(null); }}
//               />
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* GRID */}
//       <div className="properties-grid">
//         {loading ? (
//           <p>Loading properties...</p>
//         ) : filteredProperties.length === 0 ? (
//           <p>No properties found</p>
//         ) : (
//           filteredProperties.map((property, index) => (
//             <PropertyCard
//               key={property._id}
//               property={property}
//               index={index}
//               onEdit={() => { setEditingProperty(property); setShowForm(true); }}
//               onDelete={() => handleDelete(property._id)}
//               onStatusChange={handleStatusChange}
//               isAdmin={isAdmin}
//             />
//           ))
//         )}
//       </div>
//     </div>
//   );
// }

// Updated: 23-05-2026
// Changes:
// - Reads URL query params on mount (status, category, listingType, sort, search)
//   so Dashboard "Available Properties" link pre-filters to status=available
// - Added "Created By" agent filter dropdown (built from actual property data)

import React, { useEffect, useState, useCallback } from "react";
import { Plus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

import PropertyCard    from "../components/properties/PropertyCard";
import PropertyForm    from "../components/properties/PropertyForm";
import PropertyFilters from "../components/properties/PropertyFilters";
import PeriodFilterBar from "../components/common/PeriodFilterBar";

import api from "../api/api";
import { useAuth } from "../api/authContext";
import { getPeriodRange, isDateInRange } from "../utils/periodFilter";

import "../css/properties/propertypage.css";
import "../css/properties/propertyModern.css";

export default function PropertyPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, isAdmin } = useAuth();

  const [properties,      setProperties]      = useState([]);
  const [loading,         setLoading]         = useState(true);
  const [showForm,        setShowForm]        = useState(false);
  const [editingProperty, setEditingProperty] = useState(null);
  const [period,          setPeriod]          = useState("all");
  const [weekAnchor,      setWeekAnchor]      = useState(() => new Date());
  const [customFrom,      setCustomFrom]      = useState("");
  const [customTo,        setCustomTo]        = useState("");

  /* ── Parse all filters from URL (single source of truth) ── */
  const parseFiltersFromURL = useCallback(() => {
    const p = new URLSearchParams(location.search);
    return {
      search:      p.get("search")      || "",
      sort:        p.get("sort")        || "newest",
      category:    p.get("category")    || "all",
      status:      p.get("status")      || "all",
      listingType: p.get("listingType") || "all",
      createdBy:   p.get("createdBy")   || "all",
    };
  }, [location.search]);

  const [filters, setFilters] = useState(parseFiltersFromURL);

  /* ── When URL changes externally (browser back/forward, dashboard link),
        re-sync filter state — but skip if URL matches current state to avoid loop ── */
  useEffect(() => {
    const fromURL = parseFiltersFromURL();
    const isSame =
      fromURL.search      === filters.search      &&
      fromURL.sort        === filters.sort        &&
      fromURL.category    === filters.category    &&
      fromURL.status      === filters.status      &&
      fromURL.listingType === filters.listingType &&
      fromURL.createdBy   === filters.createdBy;
    if (!isSame) setFilters(fromURL);
  }, [location.search]); // eslint-disable-line

  /* ── Push filter changes into the URL so they survive navigation ── */
  const applyFilters = useCallback((newFilters) => {
    setFilters(newFilters);
    const params = new URLSearchParams();
    if (newFilters.search)                        params.set("search",      newFilters.search);
    if (newFilters.sort && newFilters.sort !== "newest") params.set("sort", newFilters.sort);
    if (newFilters.category    !== "all")         params.set("category",    newFilters.category);
    if (newFilters.status      !== "all")         params.set("status",      newFilters.status);
    if (newFilters.listingType !== "all")         params.set("listingType", newFilters.listingType);
    if (newFilters.createdBy   !== "all")         params.set("createdBy",   newFilters.createdBy);
    navigate({ search: params.toString() }, { replace: true });
  }, [navigate]);

  /* ================= AUTH GUARD ================= */
  useEffect(() => {
    if (!token) { navigate("/login"); return; }
    fetchProperties();
  }, [token]);

  /* ================= FETCH ================= */
  const fetchProperties = async () => {
    try {
      setLoading(true);
      const res = await api.get("/properties");
      setProperties(res.data || []);
    } catch (err) {
      console.error("Failed to fetch properties", err);
      if (err.response?.status === 401) navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  /* ================= CREATE / UPDATE ================= */
  const handleSubmit = async (data) => {
    try {
      const formData = new FormData();

      Object.keys(data).forEach((key) => {
        if (key !== "images" && data[key] !== undefined && data[key] !== null) {
          if (Array.isArray(data[key])) {
            data[key].forEach((item) => formData.append(`${key}[]`, item));
          } else {
            formData.append(key, data[key]);
          }
        }
      });

      if (data.images?.length) {
        data.images.forEach((file) => {
          if (file instanceof File) {
            formData.append("images", file);
          } else if (typeof file === "string") {
            formData.append("images", file);
          }
        });
      }

      if (editingProperty) {
        await api.put(`/properties/${editingProperty._id}`, formData);
      } else {
        await api.post("/properties/create", formData);
      }

      fetchProperties();
      setShowForm(false);
      setEditingProperty(null);
    } catch (err) {
      console.error("Save property error:", err);
      alert("Error saving property");
    }
  };

  /* ================= STATUS CHANGE ================= */
  const handleStatusChange = async (propertyId, newStatus) => {
    try {
      await api.patch(`/properties/${propertyId}`, { status: newStatus });
      setProperties((prev) =>
        prev.map((p) => p._id === propertyId ? { ...p, status: newStatus } : p)
      );
    } catch (err) {
      console.error("Failed to update status", err);
      alert("Failed to update property status");
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async (propertyId) => {
    if (!window.confirm("Are you sure you want to delete this property?")) return;
    try {
      await api.delete(`/properties/${propertyId}`);
      setProperties((prev) => prev.filter((p) => p._id !== propertyId));
    } catch (err) {
      console.error("Delete property error:", err);
      alert("Error deleting property");
    }
  };

  /* ── Build unique agent list from actual data ── */
  const agentOptions = [...new Set(
    properties.map((p) => p.createdByEmail).filter(Boolean)
  )].sort();

  /* ================= FILTER + SORT ================= */
  const periodRange = getPeriodRange(period, { weekAnchor, customFrom, customTo });

  const filteredProperties = (() => {
    const search = (filters.search || "").toLowerCase();

    let list = properties.filter((p) => {
      const matchSearch =
        !search ||
        p.propertyName?.toLowerCase().includes(search) ||
        p.location?.toLowerCase().includes(search);

      const matchStatus =
        filters.status === "all" || p.status === filters.status;

      const matchCategory =
        filters.category === "all" || p.propertyCategory === filters.category;

      const matchListingType =
        filters.listingType === "all" || p.listingType === filters.listingType;

      const matchAgent =
        filters.createdBy === "all" || p.createdByEmail === filters.createdBy;

      const matchPeriod = isDateInRange(p.createdDate, periodRange);

      return matchSearch && matchStatus && matchCategory && matchListingType && matchAgent && matchPeriod;
    });

    switch (filters.sort) {
      case "oldest":
        list = [...list].sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
        break;
      case "az":
        list = [...list].sort((a, b) => (a.propertyName || "").localeCompare(b.propertyName || ""));
        break;
      case "za":
        list = [...list].sort((a, b) => (b.propertyName || "").localeCompare(a.propertyName || ""));
        break;
      case "price_asc":
        list = [...list].sort((a, b) => (a.price || 0) - (b.price || 0));
        break;
      case "price_desc":
        list = [...list].sort((a, b) => (b.price || 0) - (a.price || 0));
        break;
      case "newest":
      default:
        list = [...list].sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
        break;
    }

    return list;
  })();

  /* ================= UI ================= */
  return (
    <div className="properties-page">
      <div className="properties-header">
        <div>
          <h1>Property Listings</h1>
          <p>Manage your real estate inventory</p>
        </div>
        <button
          className="add-btn"
          onClick={() => { setEditingProperty(null); setShowForm(true); }}
        >
          <Plus size={16} /> Add New Property
        </button>
      </div>

      <PeriodFilterBar
        period={period} onPeriodChange={setPeriod}
        weekAnchor={weekAnchor} onWeekAnchorChange={setWeekAnchor}
        customFrom={customFrom} onCustomFromChange={setCustomFrom}
        customTo={customTo} onCustomToChange={setCustomTo}
      />

      {/* FILTERS — all in one row, flex-wrap on small screens */}
      <div className="properties-toolbar">
        <div className="filters-container properties-filters-row">
          {/* Built-in filters — all changes go through applyFilters → URL */}
          <PropertyFilters filters={filters} setFilters={applyFilters} inline />

          {/* Created By filter */}
          <select
            className="filter-select"
            value={filters.createdBy}
            onChange={(e) => applyFilters({ ...filters, createdBy: e.target.value })}
          >
            <option value="all">All Agents</option>
            {agentOptions.map((email) => (
              <option key={email} value={email}>{email}</option>
            ))}
          </select>
        </div>
      </div>

      {/* FORM MODAL */}
      <AnimatePresence>
        {showForm && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          >
            <motion.div
              className="modal-content"
              initial={{ scale: 0.9 }} animate={{ scale: 1 }} exit={{ scale: 0.9 }}
            >
              <PropertyForm
                property={editingProperty}
                onSubmit={handleSubmit}
                onCancel={() => { setShowForm(false); setEditingProperty(null); }}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* GRID */}
      <div className="properties-grid">
        {loading ? (
          <p>Loading properties...</p>
        ) : filteredProperties.length === 0 ? (
          <p>No properties found</p>
        ) : (
          filteredProperties.map((property, index) => (
            <PropertyCard
              key={property._id}
              property={property}
              index={index}
              onEdit={() => { setEditingProperty(property); setShowForm(true); }}
              onDelete={() => handleDelete(property._id)}
              onStatusChange={handleStatusChange}
              isAdmin={isAdmin}
            />
          ))
        )}
      </div>
    </div>
  );
}